export enum ESportQueryKey {
  SPORTS = 'sports'
}
